import styled, { css } from 'styled-components';

export const MainPanelWrapper = styled.div<{ isDoctor?: boolean }>(
    ({ isDoctor }) => css`
        align-items: center;
        display: flex;
        flex-direction: column;
        padding: ${isDoctor ? '120px' : '10px'} 80px;
        width: 100%;
    `,
);
